import { render } from "./InfoNotificationModal.vue?vue&type=template&id=7716c3ea&scoped=true&ts=true"
import script from "./InfoNotificationModal.vue?vue&type=script&lang=ts"
export * from "./InfoNotificationModal.vue?vue&type=script&lang=ts"

import "./InfoNotificationModal.vue?vue&type=style&index=0&id=7716c3ea&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ms-frontend-vue_us_qa_v1.39.20_2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7716c3ea"]])

export default __exports__